module.exports = __webpack_public_path__ + "img/icon6.9be87be7.png";